module.exports = __webpack_public_path__ + "static/media/beach2381.9f3d0b34.jpg";